import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'address'
})
export class AddressPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(!value) {
      return "No Address Entered";
    }

    return `${value.firstStreetAddress || "N/A"}, ${value.secondStreetAddress ? value.secondStreetAddress + ', ' : ''}${value.cityName || "N/A"}, ${value.stateProvince ? value.stateProvince.description : "N/A"} ${value.postalCode || "N/A"}`;
  }

}
